<template>
  <section class="container mx-auto py-6 md:py-10">
    <h2 class="text-center section-heading md:mb-10">
      Bigger Chance to Grow in Diversity
    </h2>
    <div
      class="flex flex-col md:flex-row justify-center items-center mx-auto lg:w-3/4"
    >
      <template v-if="isLoading">
        <div
          v-for="i in 3"
          :key="i"
          class="pb-6 md:p-6 pt-6 text-center border-b-[0.5px] md:border-b-0 md:border-r border-bw-200 last:border-r-0 border-opacity-80"
        >
          <UtilsSkeletonLoading class="w-40 h-20 mb-4" />
          <UtilsSkeletonLoading class="w-32 h-10 mb-3 mx-auto" />
          <UtilsSkeletonLoading class="w-40 h-24" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="item in impactCareers.attributes.impact_suitmedia"
          :key="item.id"
          class="text-center border-b md:border-b-0 md:border-r border-bw-200 last:border-r-0 border-opacity-80 flex flex-col justify-between"
        >
          <div class="pt-7">
            <h3
              class="text-primary-primary text-5xl md:text-6xl !leading-normal font-medium mb-0"
            >
              {{ item.number }}+
            </h3>
            <p
              class="text-sm md:text-base font-medium mb-3 text-primary-primary"
            >
              {{ item.title }}
            </p>
          </div>
          <p class="text-sm text-bw-900 px-6 pb-7">
            {{ item.noted }}
          </p>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const impactCareers = ref([])

const getImpactCareers = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/impact-career`,
    {
      query: {
        'fields[0]': 'id',
        populate: 'impact_suitmedia'
      },
      retry: 3,
      retryDelay: 300
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Categories does not exist`
    })
  }

  return data.value
}

const result = await getImpactCareers()
impactCareers.value = result.data
</script>

<style lang="scss" scoped></style>
